import * as React from "react";

interface Props {
    message?: string;

}

const LoadingIndicatorComponent = (props: Props) => {
    const {message} = props;
    return (
        <div className="text-center loading-indicator">
            <img src={window.Styleteq.images.ajaxLoader} alt="loading"/>
            {message &&
            <div>{message}</div>
            }
        </div>
    );
};
export default LoadingIndicatorComponent;


// WEBPACK FOOTER //
// ./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx